// src/features/feeds/schemas/FeedSourceForm.schema.ts

import { z } from 'zod';
import { FEED_CONSTRAINTS } from '@/lib/constants/feed';

export const feedSourceFormSchema = z.object({
  title: z.string()
    .min(FEED_CONSTRAINTS.SOURCE_TITLE_MIN, 'Title is required')
    .max(FEED_CONSTRAINTS.SOURCE_TITLE_MAX, `Max ${FEED_CONSTRAINTS.SOURCE_TITLE_MAX} characters`),
  listId: z.number().positive('Select a playlist'),
});

export type FeedSourceFormSchemaData = z.infer<typeof feedSourceFormSchema>;
